import { useEffect, useState } from 'react';
import Select, { SingleValue } from 'react-select';

import './work-time-type.scss';

import { WorkTimeTypes } from '~modules/tabel/interfaces/work-time-types';

import { WorkTimeOption, findOptionByValue, getKeyByValue, workTimeOptions } from './work-time-type.utils';

interface WorkTimeTypeSelectProps {
	defaultValue?: WorkTimeTypes;
	isDisabled?: boolean;
	isClearable?: boolean;
	isManager?: boolean;
	className?: string;
	excluded?: WorkTimeTypes[];
	style?: Record<string, string>;
	onChange: (value?: WorkTimeTypes) => void;
	onBlur?: () => void;
}

export const WorkTimeTypeSelect = ({
	defaultValue,
	isDisabled,
	isClearable,
	isManager,
	className = '',
	style,
	excluded = [],
	onChange,
	onBlur,
}: WorkTimeTypeSelectProps) => {
	const defaultKey = defaultValue ? getKeyByValue(defaultValue) : null;
	const [selectedOption, setSelectedOption] = useState<SingleValue<WorkTimeOption>>(
		defaultKey ? findOptionByValue(defaultKey) : null,
	);

	useEffect(() => {
		const defaultKey = defaultValue ? getKeyByValue(defaultValue) : null;
		setSelectedOption(defaultKey ? findOptionByValue(defaultKey) : null);
	}, [defaultValue]);

	const handleChange = (newValue: SingleValue<WorkTimeOption>) => {
		setSelectedOption(newValue);
		onChange?.(newValue?.value ? WorkTimeTypes[newValue.value] : undefined);
	};

	return (
		<div style={style} className={`select-containe`}>
			<Select
				className={`wtt-select ${className} ${isDisabled ? 'disabled' : ''}`}
				classNamePrefix="react-select"
				options={workTimeOptions.filter(wtt => {
					const enumValue = wtt.label.split(' - ')[0] as WorkTimeTypes;
					return (
						(isManager || ![WorkTimeTypes.SickLeave, WorkTimeTypes.AnnualPaidLeave].includes(enumValue)) &&
						!excluded.includes(enumValue)
					);
				})}
				value={selectedOption}
				onChange={handleChange}
				onBlur={onBlur}
				isDisabled={isDisabled}
				isClearable={isClearable}
				placeholder="ВРВ"
				noOptionsMessage={() => 'Нет доступных опций'}
			/>
		</div>
	);
};
